import { useTranslator } from '@bluebeam/react-i18n';
import React from 'react';
import { Punch, PunchStatusValue } from 'records/Punch';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';
import ItemCount from './ItemCount';

interface Props extends WithAppStoreProps {
  onViewAllClicked: (projectId: string) => void;
  onOverdueClicked?: (projectId: string) => void;
  onActivePunchesClicked?: (projectId: string) => void;
}

const PunchItems: React.FC<Props> = (props: Props) => {
  const { translate } = useTranslator(['roverDashboard']);
  const { appState, onActivePunchesClicked, onOverdueClicked } = props;
  const { punches } = appState;

  const activePunchItems = punches.filter((p: Punch): boolean => {
    return (
      p.status !== PunchStatusValue.CLOSED &&
      p.status !== PunchStatusValue.OUT_OF_SCOPE
    );
  });

  const overduePunchItems = punches.filter((p: Punch): boolean => {
    const dueDate = new Date(p.duedate * 1000);
    return (
      dueDate < new Date() &&
      p.duedate > 0 &&
      p.status !== PunchStatusValue.CLOSED
    );
  });
  return (
    <div
      id="dashboard-punch-card-items"
      className="row w100 h100 justify-between p3"
    >
      <div className="w100 mr3">
        <ItemCount
          id="dashboard-punch-card-active-items"
          // onClicked={onActivePunchesClicked}
          count={activePunchItems.size}
          label={`${translate('roverDashboard:activePunchItems')}:`}
          doesChangeColor={false}
        />
      </div>
      <div className="w100">
        <ItemCount
          id="dashboard-punch-card-overdue-items"
          // onClicked={onOverdueClicked}
          count={overduePunchItems.size}
          label={`${translate('roverDashboard:overduePunchItems')}:`}
          doesChangeColor
        />
      </div>
    </div>
  );
};

export default withAppStore<Props>(PunchItems);
